<template>
  <div class="spt">  
    <div>
      <div class="spt-header">
        <h2>SIM PHONG THUỶ</h2>
        <div class="w-100 header dpt">
          <div class="bg1"></div>
          <div class="hcontent">
            <div class="form">
              <div class="row pt-2">
                <div class="col-lg-3 col-md-12 text">
                  Số điện thoại (<font color="red">*</font>)
                </div>
                <div class="col-lg-9 col-md-12">
                  <b-form-input :class="check && phone==''?'is-invalid':''" class="form-control phone" v-model="phone" placeholder="087xxx"/>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-lg-3 col-md-12 text">
                  Ngày sinh (<font color="red">*</font>)
                </div>
                <div class="col-4 col-lg-3">
                  <v-select :clearable="false" v-model="day" :options="range(1,32)"/>
                </div>
                <div class="col-4 pl-0 col-lg-3">
                  <v-select :clearable="false" v-model="month" :options="range(1,13)"/>
                </div>
                <div class="col-4 pl-0 col-lg-3">
                  <v-select :clearable="false" v-model="year" :options="range(1923,2031)"/>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-lg-3 col-sm-4 text">
                  Giờ sinh (<font color="red">*</font>)
                </div>
                <div class="col-lg-9 col-sm-12">
                  <v-select v-model="hour" :options="hours"/>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-lg-3 col-4 text">
                  Giới tính (<font color="red">*</font>)
                </div>
                <div class="col-lg-2 col-4 text-left">
                  <b-form-radio name="gender" value="1" v-model="gender" class="mt-lg-2">Nam</b-form-radio>
                </div>
                <div class="col-lg-2 col-4 text-left">
                  <b-form-radio name="gender" value="2" v-model="gender" class="mt-lg-2">Nữ</b-form-radio>
                </div>
              </div>
              <button class="btn btn-primary btntuoi" @click="xemphongthuy">XEM PHONG THUỶ SIM</button>
            </div>
          </div>
        </div>
      </div>
      <div class="spt-content pt-2 pb-4 mt-4 mb-0 tttc" v-if="PhongThuySim">
        <div class="cheader1">
          <h4>Thông tin thân chủ</h4>
        </div>
        <div class="ccontent1 p-3">
          <p><b></b>Thân chủ: {{PhongThuySim.v_amduong}} {{gender==1?'Nam':'Nữ'}} – sinh giờ {{hour}} – ngày {{day}}/{{month}}/{{year}} Dương lịch – {{PhongThuySim.lunarDay}} Âm lịch</p>
          <p><b>Can chi:</b><span class="text-primary font-weight-bold"> {{PhongThuySim.v_canchi}}</span></p>
          <p><b>Ngũ hành:</b><span class="text-primary font-weight-bold"> {{PhongThuySim.v_nguhanh}}</span></p>
          <p><b>Ngũ hành sinh mệnh:</b><span class="text-primary font-weight-bold"> {{PhongThuySim.v_nguhanh_sinhmenh}}</span></p>
          <p><b>Ngũ hành khắc mệnh:</b><span class="text-primary font-weight-bold"> {{PhongThuySim.v_nguhanh_khacmenh}}</span></p>
        </div>
      </div>
      <div class="spt-content pt-2 pb-4 mt-0 mb-0 kqpt" :class="removeAccents(PhongThuySim.v_menhsim)" v-if="PhongThuySim">
        <div class="cheader1">
          <h4>Kết quả phong thủy số {{phone}}</h4>
        </div>
        <div class="ccontent1 p-3">
          <p><b>Điểm phong thủy:</b><span class="text-primary font-weight-bold"> {{PhongThuySim.v_diem_phongthuy}}</span></p>
          <p><b>Sim ngũ hành:</b><span class="text-primary font-weight-bold"> {{PhongThuySim.v_menhsim}}</span></p>
          <p><b>Số nút:</b><span class="text-primary font-weight-bold"> {{PhongThuySim.v_sonut}}</span></p>
          <p><b>Vận Cát – Hung:</b><span class="text-primary font-weight-bold"> {{PhongThuySim.v_van_cathung}}</span></p>
          <div class="row"><p class="col-lg-9 col-md-9"><b>Quẻ kinh dịch:</b><span class="text-primary font-weight-bold"> {{PhongThuySim.v_kinhdich}}</span></p></div>
        </div>
      </div>
      <div class="spt-content pt-2 pb-4 mt-2 mb-0 dpt" v-if="PhongThuySim">
        <div class="row">
          <div class="col-lg-3 col-md-12">
            <h4>ĐIỂM PHONG THUỶ:</h4>
            <h5 class="pt-3">{{PhongThuySim.v_diem_phongthuy}}/10</h5>
          </div>
          <div class="col-lg-9 col-md-12 pl-4 text-center">
            <p>{{PhongThuySim.v_ynghia_diemphongthuy}}</p>
            <p>Số điện thoại: {{phone}}</p>
            <p v-if="PhongThuySim.available">Giá: {{PhongThuySim.money|number}}đ</p>
            <p v-else><b>Tình trạng:</b> không có sẵn</p>
            <b-button @click="buy(phone)" v-if="PhongThuySim.available" class="btn3" size="lg">MUA NGAY</b-button>
            <b-button @click="chonsim(0)" v-else class="btn3" size="lg">CHỌN SỐ KHÁC</b-button>
            
          </div>
        </div>
      </div>
      <div class="spt-content">
        <div class="cheader mb-4">
          <img src="@/assets/images/simphongthuy/stick.png"/>
          <h2>Danh sách sim hợp ngày sinh {{day}}/{{month}}/{{year}}</h2>
          <img src="@/assets/images/simphongthuy/stick.png"/> 
        </div>
      </div>
      <div class="spt-content c2 pl-2 pr-2 pb-1 pt-1 mb-4 pb-4" v-if="simTheoTuoi">
        <b-carousel class="w-100 product" controls>
          <b-carousel-slide v-for="(s1,stt1) in simTheoTuoi" :key="stt1">
            <template v-slot:img>
              <div class="row p05">
                  <div class="col-lg-4 col-12" v-for="(i,stt) in s1" :key="stt">
                    <div class="box1">
                      <div class="box2 p-3">
                        <div class="row">
                          <div class="col-12">
                            <h3 class="float-left">{{f087(i.phone)}}</h3>
                            <h2 class="float-right">{{i.money|number}}đ</h2>
                          </div>
                          <div class="col-12 pt-2">
                            <div class="b">Điểm phong thuỷ: <span class="text-primary font-weight-bolder">{{i.DiemPhongThuy}}/10</span></div>
                          </div>
                          <div class="col-12">
                            <div class="b">Sim ngũ hành: <span class="text-dark font-weight-bolder">{{i.SimNguHanh}}</span></div>
                          </div>
                          <div class="col-12">
                            <div class="b">Số nút: <span class="text-dark font-weight-bolder">{{i.SoNut}}</span></div>
                          </div>
                          <div class="col-12">
                            <div class="b">Vận Cát - Hung: <span class="font-weight-bolder" :class="i.VanCatHung=='CÁT' || i.VanCatHung=='ĐẠI CÁT'?'text-primary':'text-dark'">{{i.VanCatHung}}</span></div>
                          </div>
                          <div class="col-12 pb-2">
                            <div class="b">Quẻ Kinh dịch: <span class="text-dark font-weight-bold">{{i.QueKinhDich}}</span></div>
                          </div>
                          
                        </div>
                        <div class="row footer">
                          <div class="col-6">
                            <b-button @click="chonso(i.phone)" variant="outline-primary" class="rounded-pill btn-block" size="sm">Xem luận giải</b-button>
                          </div>
                          <div class="col-1"></div>
                          <div class="col-5">
                            <b-button @click="buy(i.phone)" variant="primary" class="rounded-pill btn-block" size="sm">MUA NGAY</b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>
        <div class="text-center">
          <a @click="chonsim(0)" class="ml-auto mr-auto fs-but search-mask">
            Xem tất cả
          </a>
        </div>
      </div>
      <div class="spt-content c2 pl-2 pr-2 pb-1 pt-1 mb-4 pb-4" v-if="simTaiVan">
        <h2>Sim tốt cho tài vận</h2>
        <b-carousel class="w-100 product" controls>
          <b-carousel-slide v-for="(s1,stt1) in simTaiVan" :key="stt1">
            <template v-slot:img>
              <div class="row p05">
                  <div class="col-lg-4 col-12" v-for="(i,stt) in s1" :key="stt">
                    <div class="box1">
                      <div class="box2 p-3">
                        <div class="row">
                          <div class="col-12">
                            <h3 class="float-left">{{f087(i.phone)}}</h3>
                            <h2 class="float-right">{{i.money|number}}đ</h2>
                          </div>
                          <div class="col-12 pt-2">
                            <div class="b">Điểm phong thuỷ: <span class="text-primary font-weight-bolder">{{i.DiemPhongThuy}}/10</span></div>
                          </div>
                          <div class="col-12">
                            <div class="b">Sim ngũ hành: <span class="text-dark font-weight-bolder">{{i.SimNguHanh}}</span></div>
                          </div>
                          <div class="col-12">
                            <div class="b">Số nút: <span class="text-dark font-weight-bolder">{{i.SoNut}}</span></div>
                          </div>
                          <div class="col-12">
                            <div class="b">Vận Cát - Hung: <span class="font-weight-bolder" :class="i.VanCatHung=='CÁT' || i.VanCatHung=='ĐẠI CÁT'?'text-primary':'text-dark'">{{i.VanCatHung}}</span></div>
                          </div>
                          <div class="col-12 pb-2">
                            <div class="b">Quẻ Kinh dịch: <span class="text-dark font-weight-bold">{{i.QueKinhDich}}</span></div>
                          </div>
                          
                        </div>
                        <div class="row footer">
                          <div class="col-6">
                            <b-button @click="chonso(i.phone)" variant="outline-primary" class="rounded-pill btn-block" size="sm">Xem luận giải</b-button>
                          </div>
                          <div class="col-1"></div>
                          <div class="col-5">
                            <b-button @click="buy(i.phone)" variant="primary" class="rounded-pill btn-block" size="sm">MUA NGAY</b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>
        <div class="text-center">
          <a @click="chonsim(4)" class="ml-auto mr-auto fs-but search-mask">
            Xem tất cả
          </a>
        </div>
      </div>
      <div class="spt-content c2 pl-2 pr-2 pb-1 pt-1 mb-4 pb-4" v-if="simCongDanh">
        <h2>Sim tốt cho công danh sự nghiệp</h2>
        <b-carousel class="w-100 product" controls>
          <b-carousel-slide v-for="(s1,stt1) in simCongDanh" :key="stt1">
            <template v-slot:img>
              <div class="row p05">
                  <div class="col-lg-4 col-12" v-for="(i,stt) in s1" :key="stt">
                    <div class="box1">
                      <div class="box2 p-3">
                        <div class="row">
                          <div class="col-12">
                            <h3 class="float-left">{{f087(i.phone)}}</h3>
                            <h2 class="float-right">{{i.money|number}}đ</h2>
                          </div>
                          <div class="col-12 pt-2">
                            <div class="b">Điểm phong thuỷ: <span class="text-primary font-weight-bolder">{{i.DiemPhongThuy}}/10</span></div>
                          </div>
                          <div class="col-12">
                            <div class="b">Sim ngũ hành: <span class="text-dark font-weight-bolder">{{i.SimNguHanh}}</span></div>
                          </div>
                          <div class="col-12">
                            <div class="b">Số nút: <span class="text-dark font-weight-bolder">{{i.SoNut}}</span></div>
                          </div>
                          <div class="col-12">
                            <div class="b">Vận Cát - Hung: <span class="font-weight-bolder" :class="i.VanCatHung=='CÁT' || i.VanCatHung=='ĐẠI CÁT'?'text-primary':'text-dark'">{{i.VanCatHung}}</span></div>
                          </div>
                          <div class="col-12 pb-2">
                            <div class="b">Quẻ Kinh dịch: <span class="text-dark font-weight-bold">{{i.QueKinhDich}}</span></div>
                          </div>
                          
                        </div>
                        <div class="row footer">
                          <div class="col-6">
                            <b-button @click="chonso(i.phone)" variant="outline-primary" class="rounded-pill btn-block" size="sm">Xem luận giải</b-button>
                          </div>
                          <div class="col-1"></div>
                          <div class="col-5">
                            <b-button @click="buy(i.phone)" variant="primary" class="rounded-pill btn-block" size="sm">MUA NGAY</b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>
        <div class="text-center">
          <a @click="chonsim(3)" class="ml-auto mr-auto fs-but search-mask">
            Xem tất cả
          </a>
        </div>
      </div>
      <div class="spt-content pt-0 pb-4 mt-1 mb-0 recent" v-if="sptRecent && sptRecent.length>0">
        <div class="cheader1">
          Danh sách số đã xem
        </div>
        <div class="ccontent1">
          <table class="table">
            <tr>
              <th>Số điện thoại</th>
              <th>Ngũ hành</th>
              <th>Gói cước</th>
              <th>Số điểm</th>
              <th>Giá tiền</th>
              <th></th>
            </tr>
            <tr v-for="(i,stt) in sptRecent" :key="stt">
              <td><div>{{f087(i.phone)}}</div></td>
              <td><div>{{i.v_menhsim}}</div></td>
              <td><div>{{i.pack}}</div></td>
              <td><div>{{i.v_diem_phongthuy}}/10</div></td>
              <td>{{i.money|number}}đ</td>
              <td>
                <a @click="buy(i.phone)" style="padding-top:6px;padding-bottom:6px" class="rounded-pill bg-primary pl-2 pr-2 text-white">MUA NGAY</a>
              </td>
            </tr>
          </table>
          <div class="box-recent">
            <div class="card" v-for="(i,stt) in sptRecent" :key="stt">
              <div class="card-body p-1">
                <div class="row">
                  <div class="col-6 font-weight-bold text-secondary">
                    {{f087(i.phone)}}
                  </div>
                  <div class="col-6 text-right font-weight-bold text-primary">
                    {{i.money|number}}đ
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 pr-0">
                    <p>Sim ngũ hành: {{i.v_menhsim}}</p>
                    <p>Gói cước: {{i.pack}}</p>
                    <p>Số điểm: {{i.v_diem_phongthuy}}/10</p>
                  </div>
                  <div class="col-6 text-right pl-0 pt-4">
                    <a @click="buy(i.phone)" style="padding-top:6px;padding-bottom:6px" class="rounded-pill bg-primary pl-1 pr-1 text-white">MUA NGAY</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navigation, Pagination } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import useJwt from "@/auth/jwt/useJwt";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  BPagination,BCarousel, BCarouselSlide,BFormInput,BFormGroup,BButton,BFormCheckbox,BFormRadio
} from "bootstrap-vue";
// Import Swiper styles
import "swiper/swiper-bundle.css";
import Select2 from 'v-select2-component';
import CryptoJS from "crypto-js";
SwiperCore.use([Navigation, Pagination]);
function importAll(r) {
  let images = {};
  r.keys().map((item, index) => {
    images["assets/images/ve-itel/" + item.replace("./", "")] = r(item);
  });
  return images;
}
const images = importAll(
  require.context("@/assets/images/ve-itel/", false, /.(png)$/)
);

export default {
  components: {
    Swiper,
    SwiperSlide,
    BFormInput,
    BFormGroup,BButton,
    BFormCheckbox,
    BFormRadio,
    Select2,
    BCarousel, BCarouselSlide,
    "v-select": vSelect,BPagination,
  },
  data() {
    return {
      iframeSrc: '',
      phone:'',
      year:1986,
      month:1,
      day:1,
      hour:'Tý - Từ 23 giờ đến 1 giờ sáng',
      gender:'1',
      cart_info: {
        _track: "T_" + Math.random().toString(36).slice(2),
      },
      simTheoTuoi:null,
      simTaiVan:null,
      simCongDanh:null,
      sim_types:[
        {id:1,text:'Sim Gia đạo tình duyên',type:'loc'}, 
        {id:2,text:'Sim Đại cát',type:'loc'}, 
        {id:3,text:'Sim Công danh',type:'loc'}, 
        {id:4,text:'Sim Tài lộc',type:'loc'},
      ],
      menhs:[
        {id:1,text:'Sim hợp mệnh Kim'},
        {id:2,text:'Sim hợp mệnh Mộc'}, 
        {id:3,text:'Sim hợp mệnh Thủy'}, 
        {id:4,text:'Sim hợp mệnh Hỏa'},
        {id:5,text:'Sim hợp mệnh Thổ'}
      ],
      hours: ['Tý - Từ 23 giờ đến 1 giờ sáng','Sửu - Từ 1 giờ đến 3 giờ sáng','Dần - Từ 3 giờ đến 5 giờ sáng','Mão - Từ 5 giờ đến 7 giờ sáng','Thìn - Từ 7 giờ đến 9 giờ sáng','Tỵ - Từ 9 giờ đến 11 giờ sáng','Ngọ - Từ 11 giờ đến 13 giờ trưa','Mùi - Từ 13 giờ đến 15 giờ trưa','Thân - Từ 15 giờ đến 17 giờ chiều','Dậu - Từ 17 giờ đến 19 giờ tối','Tuất - Từ 19 giờ đến 21 giờ tối','Hợi - Từ 21 giờ đến 23 giờ tối',],
      page:1,
      pageSize:100,
      check:false,
      vw: window.innerWidth,
    };
  },
  watch: {
    $route(to, from) {
      //this.$store.dispatch('simphongthuy/fetchBoiSimBoloc',this);
      this.check=false;
      this.loadData();
    },
  },
  computed:{
    BoiSimBoloc(){
      return this.$store.getters['simphongthuy/getBoiSimBoloc']
    },
    PhongThuySim(){
      return this.$store.getters['simphongthuy/getPhongThuySim']
    },
    SPTSimDetail(){
      return this.$store.getters['simphongthuy/getSPTSimDetail']
    },
    sptRecent(){
      if (localStorage.getItem('spt_recent')==null){
        return [];
      }else{
        return JSON.parse(localStorage.getItem('spt_recent'));
      }
    }
  },
  created() {

  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  mounted() {
    this.loadData();
    window.insider_object = window.insider_object || {};
    if (localStorage.trackId == undefined) {
      localStorage.trackId = Math.random().toString(36).slice(2);
    }
    if (this.$route.query && this.$route.query.cart_info){
      this.cart_info = JSON.parse(this.$route.query.cart_info);
    }
    this.tracking1(localStorage.trackId, 1);
    window.insider_object.page = {
        type: "mua-sim-phong-thuy",
    };
  },
  methods: {
    arrange(list){
      var list_ = []
      var i = 0;
      var x;
      var col_ = 6;
      if (this.vw < 768) {
        col_ = 1;
      } else if (this.vw < 1200) {
        col_ = 4;
      }
      if (list && list.length > 0) {
        list.forEach((m) => {
          if ((i + 1) % col_ == 1 || col_ == 1) {
            x = [];
            list_.push(x);
          } else {
            x = list_[list_.length - 1];
          }
          i++;
          x.push(m);
        });
      }
      return list_;
    },
    async buy(phone){
      var x = await this.$store.dispatch('simphongthuy/fetchSPTSimDetail',{vm:this,phone:phone});
      console.log(x);
      window.insider_object.page = {
        type: "AddToCart",
      };
      //var tid = "T_" + Math.random().toString(36).slice(2);
      //var cart_info = {"shipment_type":"home","_track":tid,"isSimPhongThuy":1};
      //return;
      this.$router.push({path:'/mua-hang/buoc/2',query:{currentPhone:phone,cart:JSON.stringify(x),cart_info:JSON.stringify(this.cart_info)}});
    },
    tracking(id, step) {
      const parsedParams = this.$route.query;
      this.$route.hash.split("&").map((part) => part.replace(/^#/, "")).forEach((param) => {
          const parts = param.split("=");
          parsedParams[parts[0]] = parts[1];
        });
      useJwt.post("tracking/" + id + "/" + step, {
          cart_info: this.cart_info,
          query: parsedParams,
        }).then((response) => {
          //console.log(response.data.result)
        });
    },
    loadData(){
      if (this.$route.query.dob && this.$route.query.dob.length>=8){
        var x = this.$route.query.dob.split("/");
        this.day = x[0];
        this.month = x[1];
        this.year = x[2];
        this.phone = this.$route.query.phone;
        this.hour = this.$route.query.hour;
        this.gender = this.$route.query.gender;
      }
      if (this.phone && this.phone.length==10){
        this.$store.dispatch('simphongthuy/fetchPhongThuySim',this);
      }
      this.$store.dispatch('simphongthuy/fetchBoiSimBolo1',{vm:this,dob:this.day+"/"+this.month+"/"+this.year,sim_type:0,page:1,pageSize:60}).then(resp=>{
        this.simTheoTuoi = this.arrange(resp);
        console.log(this.simTheoTuoi);
      });
      this.$store.dispatch('simphongthuy/fetchBoiSimBolo1',{vm:this,dob:this.day+"/"+this.month+"/"+this.year,sim_type:4,page:1,pageSize:60}).then(resp=>{
        //this.simTaiVan = resp;
        this.simTaiVan = this.arrange(resp);
        console.log(this.simTaiVan);
      });
      this.$store.dispatch('simphongthuy/fetchBoiSimBolo1',{vm:this,dob:this.day+"/"+this.month+"/"+this.year,sim_type:3,page:1,pageSize:60}).then(resp=>{
        //this.simCongDanh = resp;
        this.simCongDanh = this.arrange(resp);
      });
    },
    removeAccents(str) {
      if (str){
        return str.normalize("NFD").replace(/\p{Diacritic}/gu, "");
      }else{
        return str;
      }
    },
    range(start, end) {
      var count = end - start;
        if(arguments.length == 1) {
            count = start;
            start = 0;
        }

        var foo = [];
        for (var i = 0; i < count; i++) {
            foo.push(start + i);
        }
        return foo;
    },
    chonso(phone){
      this.$router.push({ name: "diem-phong-thuy", query:{gender:this.gender,hour:this.hour,phone:phone,dob:this.day+"/"+this.month+"/"+this.year,
      cart_info: JSON.stringify(this.cart_info),
    } });
    },
    chonsim(type, menh) {
      const key="Everchosen"
      if (menh) {
        const encryptedGender =CryptoJS.AES.encrypt(this.gender,key).toString()
        const encryptedDob =  CryptoJS.AES.encrypt(this.day + "/" + this.month + "/" + this.year,key).toString()
        this.$router.push({
          name: "sim-phong-thuy-boloc",
          query: {
            gender: encryptedGender,
            hour: this.hour,
            menh: 1,
            type: type,
            day: encryptedDob,
            cart_info: JSON.stringify(this.cart_info),
          }
        });
      } else {
        // console.log("gender",this.gender)
        const encryptedGender = CryptoJS.AES.encrypt(this.gender,"Everchosen").toString()
        const encryptedDob =  CryptoJS.AES.encrypt(this.day + "/" + this.month + "/" + this.year,"Everchosen").toString()
        // console.log(this.day + "/" + this.month + "/" + this.year)
        // console.log("query",encryptedGender,encryptedDob)
        this.$router.push({
          name: "sim-phong-thuy-boloc",
          query: {
            gender: encryptedGender,
            hour: this.hour,
            type: type,
            day: encryptedDob,
            cart_info: JSON.stringify(this.cart_info),
          }
        });
      }
    },
    xemphongthuy(){
      //this.loadData();
      this.check=true;
      if (this.phone.length!=10 || this.phone.indexOf('0')!=0){
        this.$toast.error( 'Vui lòng nhập số điện thoại, dạng 0x!', { icon: true, closeButton: 'button' });
        return;
      }
      //this.$store.dispatch('simphongthuy/fetchPhongThuySim',this);
      this.$router.push({ name: "diem-phong-thuy", query:{gender:this.gender,hour:this.hour,phone:this.phone,dob:this.day+"/"+this.month+"/"+this.year,
      cart_info: JSON.stringify(this.cart_info),
    } });
    },
    f087(value) {
      if (value){
        return value.substr(0, 4) + " " + value.substr(4);
      }else{
        return value;
      }
    },
    Img(pic) {
      return images[pic];
    },
    tracking1(id_, step) {
      var id = id_;
      if (!id_){
        localStorage.trackId = Math.random().toString(36).slice(2);
        id = localStorage.trackId;
      }
      const parsedParams = this.$route.query;
      this.$route.hash
          .split("&")
          .map((part) => part.replace(/^#/, ""))
          .forEach((param) => {
            const parts = param.split("=");
            parsedParams[parts[0]] = parts[1];
          });
      useJwt
          .post("tracking/" + id + "/" + step, {
            cart_info: this.cart_info,
            cart: this.cart,
            query: parsedParams,
          })
          .then((response) => {
            //console.log(response.data.result)
          });
    },
  },
};
</script>
<style lang="scss">
.spt .header{
  position: relative;
  z-index: 1;
  height: 590px;
  margin-top: 30px;
}
.spt .header.dpt{
  position: relative;
  z-index: 1;
  height: 420px;
  margin-top: 30px;
}
.spt .header .hcontent{
  padding: 41px;
  text-align: center;
  width: 100%;
}
.spt .header .btntuoi{
  border-radius: 28.7953px !important;
  height: 60px;
  font-weight: 700;
  font-size: 16px;
  margin-top: 20px;
  width: 407px;
}
.spt .header .hcontent .form .text{
  line-height: 50px;
  font-weight: 700;
  font-size: 15px;;
}
.spt .header .hcontent .form h4{
  font-weight: 500 !important;
  font-size: 15px;
  line-height: 35px;
  margin-top:20px;
  border-top: 2px solid #ED1F24;
  margin-left:auto;
  margin-right:auto;
  width: 360px;
}
@media (min-width: 992px) { 
  .spt .header .hcontent .form{
    width: 60%;
  }
  .spt .spt-header h2{
    color: #424242;
    width: 50%;
    text-align: left;
  }
  .spt .spt-content.dpt {
    padding: 55px 80px !important;
  }
  .spt .spt-content.dpt .col-lg-3{
    border-right: 3px solid #FFEB90;
  }
  .spt .spt-content.recent .box-recent{
    display: none;
  }
}
@media (max-width: 992px) { 
  .spt .spt-content .loc{
    height: 35px !important;
    line-height: 35px !important;
    padding: 0 10px !important;
    font-weight: 600;
    font-size: 13.9242px !important;
    display: inline-block;
    margin-right: 5px !important;
    margin-top: 5px !important;
  }
  .spt .spt-content.recent table{
    display: none;
  }
  .spt .spt-content .ccontent1{
    padding: 10px 10px 10px 10px !important;
  }
  .spt .spt-header{
    margin-right: 15px;
    margin-left: 15px;
    width: auto !important;
  }
  .spt .header .hcontent .form{
    width: 100%;
  }
  .spt .header .hcontent .form-control{
    margin-top: 10px;
  }
  .spt .header.dpt{
    height: auto;
  }
  .spt .header .hcontent{
    padding: 10px 25px 30px 25px !important;
  }
  .spt .spt-header h2{
    color: #424242;
    width: 100%;
    text-align: center;
  }
  .spt .header .hcontent .form .text{
    line-height: 22px !important
  }
  .spt .header img, .spt .header .btntuoi{
    max-width: 100%;
  }
  .spt .spt-content .cheader img{
    display: none !important
  }
  .spt .spt-content .cheader h2{
    width: 100% !important;
  }
  .spt .spt-content.tttc, .spt .spt-content.kqpt,  .spt .spt-content.dpt{
    margin-left: 15px;
    margin-right: 15px;
    width: auto;
  }
  .spt .spt-content.Kim::after,.spt .spt-content.Kim::after,.spt .spt-content.Moc::after,.spt .spt-content.Hoa::after,.spt .spt-content.Tho::after{
    opacity: 0.3;
    top: 0 !important;
    bottom: auto !important;
    transform: scale(.25) translate(140%, -80%) !important;
  }
  .spt .spt-content.tttc::after{
    opacity: 0.3;
    transform: scale(.25) translate(170%, 150%) !important;
  }
  .spt .spt-content.dpt {
    background: url('~@/assets/images/simphongthuy/bg5.png') !important;
    background-size: 100% 100% !important;
    padding: 30px 35px !important;
  }
  .spt .spt-content.dpt h4{
    text-align: center;
  }
  .spt .spt-content.dpt p{
    font-size: 18px !important;
  }
  .spt .spt-content.dpt .col-lg-3 h5{
    padding-bottom: 10px;
    border-bottom: 3px solid #FFEB90;
  }
}
.spt .header .hcontent .form{
  max-width: 500;
  margin-left: auto;
  margin-right: auto;
}
.spt .header .hcontent h3{
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: #000000;
}
.spt .header .bg1::before{
  content: url('~@/assets/images/simphongthuy/flower1.png');
  position: absolute;
  top: 0;
  left:0;
  transform: scale(.5) translate(-70%, -70%);;
}
.spt .header .hcontent::after{
  content: url('~@/assets/images/simphongthuy/flower3.png');
  position: absolute;
  top: 0;
  right:0;
  transform: scale(.5) translate(0%, -90%);;
}
.spt .header .bg1::after{
  content: url('~@/assets/images/simphongthuy/flower1.png');
  position: absolute;
  bottom: 0;
  right:0;
  transform: scale(.5) translate(70%, 70%);;
}
.spt .header .bg1{
  background: url('~@/assets/images/simphongthuy/mask3.png') no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  border:1px solid #E5E5E5;
  opacity: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.15));
}
.spt {
    max-width: 122.4rem;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}
.spt .spt-content .loc{
  color: #fff;
  background: #ED1F24;
  border-radius: 34.809px;
  height: 45px;
  line-height: 45px;
  padding: 0 16px;
  font-weight: 600;
  font-size: 17.9242px;
  display: inline-block;
  margin-right: 10px;
  margin-top: 10px;
}
.spt .spt-content .c1 h3{
  font-weight: 800;
  font-size: 32px;
  line-height: 132.69%;
  //display: flex;
  align-items: center;
  color: #3E3E3E;
}
.spt .spt-content .c1 p{
  padding-top: 10px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  //display: flex;
  align-items: center;

  color: #000000;
}
.spt .spt-content .cheader{
  margin-top: 40px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.spt .spt-content .cheader h2{
  width: 40%;
  display: inline-block;
  color: #D20E27
}
.spt .spt-content .cheader img{
  width: 25%;
  display: inline-block;
  width: 161px;
  margin-bottom: 12px;
}
.spt .spt-content h2{
  font-weight: 700;
  font-size: 26px;
  line-height: 132.69%;
  align-items: center;
  text-align: center;
}
.spt .spt-header,.spt .spt-content {
    width: 100%;
}
.spt .spt-header h2{
  font-weight: 700;
  font-size: 24px;
  line-height: 69px;
  color: #424242;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.spt .spt-content .cheader1{
  height: 52px;
  border-radius: 8px 8px 0px 0px;
  background: url('~@/assets/images/simphongthuy/mask1.png') center no-repeat;
  background-size: cover;
  width: 100%;
  font-weight: 800;
  font-size: 25px;
  line-height: 52px;
  align-items: center;
  text-align: center;
  color: #FFE895;
}
.spt .spt-content .cheader1 h4{
  font-weight: 700;
  font-size: 21px;
  line-height: 52px;
  text-align: left;
  padding-left: 20px;
  color: #FFFFFF !important;
}
.spt .spt-content.tttc,.spt .spt-content.kqpt{
  position: relative;
}
.spt .spt-content.tttc::after{
  content: url('~@/assets/images/simphongthuy/itel1.png');
  position: absolute;
  bottom: 3.5rem;
  right:0;
  transform: scale(.5) translate(70%, 50%);;
}
.spt .spt-content.Kim::after{
  content: url('~@/assets/images/simphongthuy/Kim.png');
  position: absolute;
  bottom: 4rem;
  right: 0.5rem;
  transform: scale(.45) translate(50%, 55%);;
}
.spt .spt-content.Moc::after{
  content: url('~@/assets/images/simphongthuy/Moc.png');
  position: absolute;
  bottom: 4rem;
  right: 0.5rem;
  transform: scale(.45) translate(50%, 55%);;
}
.spt .spt-content.Thuy::after{
  content: url('~@/assets/images/simphongthuy/Thuy.png');
  position: absolute;
  bottom: 4rem;
  right: 0.5rem;
  transform: scale(.45) translate(50%, 55%);;
}
.spt .spt-content.Hoa::after{
  content: url('~@/assets/images/simphongthuy/Hoa.png');
  position: absolute;
  bottom: 4rem;
  right: 0.5rem;
  transform: scale(.45) translate(50%, 55%);;
}
.spt .spt-content.Tho::after{
  content: url('~@/assets/images/simphongthuy/Tho.png');
  position: absolute;
  bottom: 4rem;
  right: 0.5rem;
  transform: scale(.45) translate(50%, 55%);;
}
.spt .spt-content .ccontent1 p{
  line-height: 2;
}
.spt .spt-content.recent{
  margin-left:15px;
  margin-right: 15px;
  width:auto;
}
.spt .spt-content .ccontent1 table th, .spt .spt-content .ccontent1 table td{
  border-top: none !important;
}
.spt .spt-content .ccontent1 table th div, .spt .spt-content .ccontent1 table td  div{
  border-right: 2px solid #D20E27;
}
.spt .spt-content .ccontent1{
  width: 100%;
  border-radius: 0px 0px 8px 8px;
  border-left: 1px solid #D20E27;
  border-bottom: 1px solid #D20E27;
  border-right: 1px solid #D20E27;
  font-size: 18px;
  line-height: 1.5;
  padding: 30px;
}
.spt .spt-content.c2{
  background: #f9f9f9;
  border: 1px solid #f3f3f3;
  border-radius: 8px;
}
.spt .spt-content.c2 .box1{
  background: #FFFFFF;
  box-shadow: -2.44385px 0px 3.66577px rgba(0, 0, 0, 0.15);
  border-radius: 6.53271px;
  width: 100%;
}
.spt .spt-content.c2 .box2{
  width: 100%;
  min-height: 300px;
  background: url('~@/assets/images/simphongthuy/mask2.png') bottom no-repeat;
  background-size: cover;
  margin:10px 0;
}
.spt .spt-content.c2 .box2 .footer{
  position: absolute;
  bottom: 3.5rem;
  width: calc(100% - 6rem);
}
.spt .spt-content.c2 .box2:hover {
  border: 1px solid #E9182C;
  border-radius: 6.53271px;
}
.spt .spt-content.c2 .box2 h3{
  font-weight: 800;
  font-size: 19.5981px;
  line-height: 23px;
  color: #4D4D4D;
}
.spt .spt-content.c2 .box2 h2{
  font-weight: 800;
  font-size: 25px;
  line-height: 23px;
  color: #FF0006;
}
.spt .spt-content.c2 .box2 .b::before{
  padding-right: 6px;
  content: url('data:image/svg+xml;base64,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')
}
.spt .spt-content.c2 .box2 .b{
  font-size: 13px;
  line-height: 20px;
}
.spt .spt-content.c2 .box2 .btn{
  padding: 0.5rem 1.3rem !important;
  height: 3.5rem;
  font-weight: 500;
  font-size: 13.4412px;
  border-radius: 50rem !important;
}
.spt .spt-content.dpt{
  background: url('~@/assets/images/simphongthuy/bg2.png');
  background-size: 100% 100%;
  min-height: 260px;
  position: relative;
  padding:55px 80px;
}
.spt .spt-content.dpt h4{
  font-weight: 800;
  font-size: 25px;
  color: #FFE895;
}
.spt .spt-content.dpt h5{
  font-family: 'Lobster';
  font-size: 80px !important;
  font-weight: 800;
  color: #FFE895;
  text-align: center;
}
.spt .spt-content.dpt p{
  font-weight: 500;
  font-size: 23.232px;
  line-height: 1.5;
  color:#fff;
  margin-bottom: 10px;
}
.spt .spt-content.dpt .btn3{
  border-radius: 50rem !important;
  font-size: 22px !important;
  color: #D20E27 !important;
  background: #fff !important;
  height: 58px;
  font-weight: 800;
  width: 240px;
}
.spt .p05{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.spt .carousel-control-prev, .spt .carousel-control-next{
  width: 5%;
}
.spt .vs__dropdown-toggle{
  border-radius: 1rem;
  height: 5rem !important;
}
.spt .vs__actions{
  padding: 4px 16px 0px 3px;
}
.spt .vs__selected-options {
    padding: 3px 3px 3px 3px;
}
.spt .vs__selected-options span{
  font-size: 2rem;
  font-weight: 500;
}
.vs__search, .vs__search:focus, .spt .phone{
  font-size: 2rem !important;
  font-weight: 500 !important;
}
</style>